export function SendKeyIcon({ className }: { className: string }) {
    return (
        <svg
            className={className}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M13 4v3a2 2 0 0 1-2 2H3" />
            <polyline points="6,6 3,9 6,12" />
        </svg>
    );
}
